<template>
  <el-table :data="list" stripe style="width: 100%">
    <el-table-column label="Название" prop="name" />
    <el-table-column fixed="right" width="120">
      <template slot-scope="scope">
        <el-button
          size="small"
          type="success"
          @click="onEdit(scope.row.id)"
        >
          <i class="far fa-edit" />
        </el-button>

        <el-button
          size="small"
          type="danger"
          @click="onDelete(scope.row.id)"
        >
          <i class="far fa-trash-alt" />
        </el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import {mapActions, mapState} from 'vuex'

export default {
  name: 'List',
  computed: {
    ...mapState('help-center', {
      list: 'ticketCategories',
    }),
  },
  methods: {
    ...mapActions('help-center', [
      'deleteTicketCategory',
      'fetchTicketCategories',
    ]),
    onEdit(id) {
      this.$router.push({name: 'UpdateTicketCategory', params: {id}})
    },
    async onDelete(id) {
      try {
        const res = await this.$confirm('Вы действительно хотите удалить категорию?')
        if (res) {
          await this.deleteTicketCategory(id)
          await this.fetchTicketCategories()
        }
      } catch {
      }
    },
  },
}
</script>
